import { render, staticRenderFns } from "./NcnpCallback.vue?vue&type=template&id=63fc47e5&scoped=true"
import script from "./NcnpCallback.vue?vue&type=script&lang=js"
export * from "./NcnpCallback.vue?vue&type=script&lang=js"
import style0 from "./NcnpCallback.vue?vue&type=style&index=0&id=63fc47e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc47e5",
  null
  
)

export default component.exports